import React, { useState, useEffect, useRef } from 'react';
import Autoplay from 'embla-carousel-autoplay';
import { Users, GraduationCap, Briefcase, FolderKanban, Youtube, ArrowRight, Globe, Bot, Orbit, Compass, Boxes } from 'lucide-react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './ui/carousel';

export const SERVICES = [
  {
    id: 'connect',
    name: 'Connect',
    subtitle: 'Rede Profissional',
    description: 'A maior rede de profissionais BIM da América Latina',
    icon: Users,
    image: 'https://images.unsplash.com/photo-1563461661026-49631dd5d68e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    overlay: 'from-orange-600/85 via-red-700/75 to-black/90',
    accent: 'bg-orange-500',
    brandLogo: '/logos/connect.png',
    path: '/connect',
  },
  {
    id: 'bimmap',
    name: 'Map',
    subtitle: 'Comunidade',
    description: 'O mapa mundial de profissionais e empresas BIM. Cadastre-se grátis.',
    icon: Globe,
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    overlay: 'from-red-600/85 via-orange-700/75 to-black/90',
    accent: 'bg-red-500',
    brandLogo: '/logos/bimmap.png',
    path: '/bimmap',
  },
  {
    id: 'bimia',
    name: 'IA',
    subtitle: 'Suporte com IA',
    description: 'Tire dúvidas de Revit na hora com nossa IA especialista, 24/7.',
    icon: Bot,
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    overlay: 'from-indigo-600/85 via-violet-700/75 to-black/90',
    accent: 'bg-indigo-500',
    brandLogo: '/logos/bimia.png',
    path: '/bim-ia',
  },
  {
    id: 'digitaltwin',
    name: 'Digital Twin',
    subtitle: 'Gêmeos Digitais',
    description: 'Gêmeos Digitais, IoT e As Built 3D para operar e monitorar seus ativos em tempo real.',
    icon: Orbit,
    image: 'https://static.prod-images.emergentagent.com/jobs/2b41e164-3d6f-488e-a974-c4593600dbb3/images/33d0bc9d16a3b720d7d3814c480c86068cac28b7eb2e19300c0bfffc4652055e.jpeg',
    overlay: 'from-cyan-600/85 via-teal-800/75 to-black/90',
    accent: 'bg-cyan-500',
    brandLogo: '/logos/digitaltwin.png',
    path: '/digital-twin',
  },
  {
    id: 'academy',
    name: 'Academy',
    subtitle: 'Educação',
    description: 'Cursos e formações do básico ao expert',
    icon: GraduationCap,
    image: 'https://images.unsplash.com/photo-1561089489-f13d5e730d72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    overlay: 'from-red-600/85 via-pink-700/75 to-black/90',
    accent: 'bg-red-500',
    brandLogo: '/logos/academy.png',
    path: '/academy',
  },
  {
    id: 'mentor',
    name: 'Mentor',
    subtitle: 'Mentoria',
    description: 'Mentorias personalizadas de BIM — do estudante ao gestor estratégico.',
    icon: Compass,
    image: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    overlay: 'from-amber-600/85 via-orange-700/75 to-black/90',
    accent: 'bg-amber-500',
    path: '/mentor',
  },
  {
    id: 'library',
    name: 'Library',
    subtitle: 'Bibliotecas BIM',
    description: 'Bibliotecas BIM gratuitas de diversos fabricantes e a maior biblioteca nacional, a BIM BR.',
    icon: Boxes,
    image: 'https://images.unsplash.com/photo-1568667256549-094345857637?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    overlay: 'from-violet-600/85 via-purple-800/75 to-black/90',
    accent: 'bg-violet-500',
    path: '/bim-library',
  },
  {
    id: 'consultoria',
    name: 'Consultoria',
    subtitle: 'Estratégia',
    description: 'Implantação BIM para sua empresa',
    icon: Briefcase,
    image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    overlay: 'from-blue-600/85 via-cyan-700/75 to-black/90',
    accent: 'bg-blue-500',
    brandLogo: '/logos/consultoria.png',
    path: '/consultoria',
  },
  {
    id: 'projetos',
    name: 'Projetos',
    subtitle: 'Execução',
    description: 'Projetos BIM completos para construção',
    icon: FolderKanban,
    image: 'https://images.unsplash.com/photo-1508450859948-4e04fabaa4ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    overlay: 'from-emerald-600/85 via-teal-700/75 to-black/90',
    accent: 'bg-emerald-500',
    brandLogo: '/logos/projetos.png',
    path: '/projetos',
  },
  {
    id: 'talks',
    name: 'Talks',
    subtitle: 'Conteúdo',
    description: 'Canal no YouTube com lives e conteúdo gratuito sobre BIM',
    icon: Youtube,
    image: 'https://images.pexels.com/photos/11748185/pexels-photo-11748185.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1200',
    overlay: 'from-red-700/85 via-red-900/80 to-black/95',
    accent: 'bg-red-600',
    brandLogo: '/logos/talks.png',
    path: '/bimtalks',
  },
];

const ServiceCarouselCard = ({ service, onClick }) => {
  const Icon = service.icon;
  const isComingSoon = service.comingSoon;
  return (
    <button
      onClick={isComingSoon ? undefined : onClick}
      disabled={isComingSoon}
      aria-disabled={isComingSoon}
      className={`group relative block w-full h-[380px] rounded-3xl overflow-hidden text-left focus:outline-none focus:ring-2 focus:ring-white/40 ${isComingSoon ? 'cursor-not-allowed' : ''}`}
      data-testid={`carousel-card-${service.id}`}
    >
      <img
        src={service.image}
        alt={service.name}
        className={`absolute inset-0 w-full h-full object-cover transition-transform duration-700 ${isComingSoon ? 'grayscale' : 'group-hover:scale-110'}`}
      />
      <div className={`absolute inset-0 bg-gradient-to-t ${service.overlay} transition-opacity duration-500 ${isComingSoon ? '' : 'group-hover:opacity-90'}`} />
      {isComingSoon && <div className="absolute inset-0 bg-zinc-900/60 backdrop-grayscale" />}

      {service.brandLogo && (
        <img
          src={service.brandLogo}
          alt={`AJ BIM ${service.name}`}
          className={`absolute top-5 left-6 h-6 w-auto object-contain z-10 drop-shadow-md ${isComingSoon ? 'opacity-70' : ''}`}
        />
      )}

      {isComingSoon && (
        <div className={`absolute top-7 -right-12 z-20 rotate-45 ${service.accent} text-white text-xs font-bold uppercase tracking-wider px-14 py-1.5 shadow-lg`}>
          Em breve
        </div>
      )}

      <div className="relative h-full flex flex-col justify-end p-7">
        <div className={`w-14 h-14 rounded-xl ${service.accent} flex items-center justify-center mb-4 shadow-lg ${isComingSoon ? 'opacity-80' : 'group-hover:scale-110'} transition-transform duration-300`}>
          <Icon size={28} className="text-white" />
        </div>
        <p className="text-white/70 text-xs uppercase tracking-[0.2em] mb-1">{service.subtitle}</p>
        <h3 className="text-white font-bold text-2xl mb-2">AJ | BIM {service.name}</h3>
        <p className="text-white/80 text-sm leading-relaxed mb-4 max-w-xs">{service.description}</p>
        {isComingSoon ? (
          <div className="flex items-center text-white/70">
            <span className="text-sm font-medium">Em breve disponível</span>
          </div>
        ) : (
          <div className="flex items-center text-white/80 group-hover:text-white transition-colors">
            <span className="text-sm font-medium">Explorar</span>
            <ArrowRight size={16} className="ml-2 transform group-hover:translate-x-1.5 transition-transform" />
          </div>
        )}
      </div>
    </button>
  );
};

export const ServiceCardsCarousel = ({ onNavigate }) => {
  const autoplay = useRef(
    Autoplay({ delay: 4000, stopOnMouseEnter: true, stopOnInteraction: false })
  );
  const [api, setApi] = useState(null);
  const START_INDEX = SERVICES.findIndex((s) => s.id === 'academy');
  const [selected, setSelected] = useState(START_INDEX);

  useEffect(() => {
    if (!api) return;
    const onSelect = () => setSelected(api.selectedScrollSnap());
    onSelect();
    api.on('select', onSelect);
    api.on('reInit', onSelect);
    return () => {
      api.off('select', onSelect);
      api.off('reInit', onSelect);
    };
  }, [api]);

  const handleCardClick = (service) => {
    if (service.comingSoon) return;
    if (typeof window !== 'undefined' && window.posthog) {
      window.posthog.capture('service_card_click', {
        service_id: service.id,
        service_name: service.name,
        path: service.path,
        source: 'home_carousel',
      });
    }
    onNavigate(service.path);
  };

  return (
    <div className="relative w-full max-w-7xl mx-auto" data-testid="service-cards-carousel">
      <Carousel
        opts={{ align: 'center', loop: true, startIndex: START_INDEX }}
        plugins={[autoplay.current]}
        setApi={setApi}
        className="w-full"
      >
        <CarouselContent className="-ml-4">
          {SERVICES.map((service) => (
            <CarouselItem
              key={service.id}
              className="pl-4 basis-[80%] sm:basis-[58%] md:basis-[46%] lg:basis-[36%]"
            >
              <ServiceCarouselCard
                service={service}
                onClick={() => handleCardClick(service)}
              />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious
          className="left-1 md:left-3 bg-white/15 border-white/25 text-white hover:bg-red-600 hover:text-white hover:border-red-600 backdrop-blur-sm"
          data-testid="carousel-prev"
        />
        <CarouselNext
          className="right-1 md:right-3 bg-white/15 border-white/25 text-white hover:bg-red-600 hover:text-white hover:border-red-600 backdrop-blur-sm"
          data-testid="carousel-next"
        />
      </Carousel>

      {/* Indicadores (dots) */}
      <div className="flex items-center justify-center gap-2 mt-6" data-testid="carousel-dots">
        {SERVICES.map((service, i) => (
          <button
            key={service.id}
            onClick={() => api && api.scrollTo(i)}
            aria-label={`Ir para ${service.name}`}
            data-testid={`carousel-dot-${service.id}`}
            className={`h-2 rounded-full transition-all duration-300 ${
              selected === i ? 'w-8 bg-red-600' : 'w-2 bg-white/30 hover:bg-white/50'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default ServiceCardsCarousel;
